import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useSubmitAdvancedDialog = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISubmitAdvancedDialogRequestData) =>
        await send<Types.ISubmitAdvancedDialogRequestData>({
            ID: 35598,
            responses: [35599, 35600],
            description: 'Submit Advanced Dialog',
            ...request
        }), [send]);
};
